import { EmptySection, SourceLink } from "~/components/vulnerabilities";
import React from "react";
import { GetRemediationQuery } from "~/operations";
import Typography from "@mui/material/Typography";
import { Link } from "@mui/material";

export const RemediationEmptyState = ({
  remediation,
  topSourceLink,
}: {
  remediation: GetRemediationQuery["remediationForScope"];
  topSourceLink?: SourceLink;
}) => {
  const isRemediationNotFound =
    remediation?.__typename === "VulnerabilityRemediationNotFound";
  const isRemediationNotSupported =
    remediation?.__typename === "VulnerabilityRemediationNotSupported";
  const isRemediationUnknown =
    remediation?.__typename === "VulnerabilityRemediationUnknown";

  // If the remediation is not supported yet, guide the user to an external source
  const remediationNotSupportedText = topSourceLink ? (
    <Typography>
      Remediation for this package is not yet supported. See{" "}
      <Link href={topSourceLink?.href} target="_blank">
        {topSourceLink?.text}
      </Link>
      .
    </Typography>
  ) : (
    "Remediation for this package is not yet supported."
  );

  return (
    <>
      {isRemediationNotFound && (
        <EmptySection
          id="software-remediation-empty"
          text="There is currently no software to remediate."
        />
      )}
      {isRemediationNotSupported && (
        <EmptySection
          id="software-remediation-unsupported"
          text={remediationNotSupportedText}
        />
      )}
      {isRemediationUnknown && (
        <EmptySection
          id="software-remediation-unknown"
          text="Remediation for this package does not exist yet."
        />
      )}
    </>
  );
};
